import React, { Component, Fragment, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import CircularProgress from "@material-ui/core/CircularProgress";
import Card from "@material-ui/core/Card";
import List from "@material-ui/core/List";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import Divider from "@material-ui/core/Divider";
import { ListItemText } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Arbitrator from "../../components/Arbitrator";
import Input from "@material-ui/core/Input";
import Button from "@material-ui/core/Button";
import UploadDocSingleFile from "../../components/UploadDocSingleFile";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import CardActions from "@material-ui/core/CardActions";
import Grid from "@material-ui/core/Grid";

const styles = (theme) => ({
  root:{
    display: "flex",
    flexDirection: "column",
    alignItem: "center",
    // marginTop:'600px',
    // '@media (max-width: 576px)': {
    //   marginTop:'10px',
    // }
  },
  formControl: {
    margin: theme.spacing.unit * 1,
  },
  group: {},
  radio: {
    "&$checked": {
      color: "#B71C1C",
    },
  },
  checked: {},
  progress: {
    /*display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItem: 'center',*/
    flexDirection: "column",
    margin: theme.spacing.unit * 3,
  },
  button: {
    // display:'flex',
    //justifyContent: 'center',
    // margin: '0 Auto',
  },
});

class UploadDocsSingleFile extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    totaluploadFiles: 1,
    files: [],
    reset: false,
    uniqueId: localStorage.getItem("token"),
    uploading: false,
    uploadingFullPdf: false,
    typeOfAccount: localStorage.getItem("typeOfAccount"),
    userType:
      localStorage.getItem("typeOfAccount") == "arbitrator"
        ? "arbitrator"
        : localStorage.getItem("typeOfAccount") == "admin"
        ? "admin"
        : this.props.claimantUniqueId == localStorage.getItem("token")
        ? "claimant"
        : this.props.respondentUniqueId == localStorage.getItem("token")
        ? "respondent"
        : null,
  };

  componentDidMount() {}

  handleChange = (prop) => (event) => {
    this.setState({ [prop]: event.target.value });
  };

  handleOnAddIcon = () => {
    this.setState((state) => ({
      totaluploadFiles: state.totaluploadFiles + 1,
    }));
  };

  handleAddFile = (file, doc_name) => {
    this.props.addFile(file, doc_name);
  };

  handleResetFile = (filename) => {
    this.props.removeFile(filename);
  };
  handleResetAll = () => {
    this.setState({
      totaluploadFiles: 1,
      files: [],
      reset: false,
    });
  };

  submitHandler = () => {
    this.setState({ uploading: true });
    let userType = "";
    if (this.props.claimantUniqueId == this.state.uniqueId) {
      userType = "claimant";
    } else if (this.props.respondentUniqueId == this.state.uniqueId) {
      userType = "respondent";
    }
    this.props.uploadDocs(
      this.props.files,
      this.props.caseData.conversationId,
      this.props.caseId,
      userType,
      this.props.doc_type
    );
    this.handleResetAll();
  };

  submitHandlerUploadFullPdf = () => {
    this.setState({ uploadingFullPdf: true });
    let userType = "";
    if (this.props.claimantUniqueId == this.state.uniqueId) {
      userType = "claimant";
    } else if (this.props.respondentUniqueId == this.state.uniqueId) {
      userType = "respondent";
    }
    this.props.uploadFullPDFDoc(
      this.props.files,
      this.props.caseData.conversationId,
      this.props.caseId,
      userType,
      this.props.doc_type
    );
    this.handleResetAll();
  };

  toggleReset = () => {
    this.setState((prevState) => ({
      reset: !prevState.reset,
    }));
  };

  render() {
    const { classes, isLoading, arbitrators } = this.props;
    return (
      <div //onSubmit={this.submitHandler}
      //  style={{marginTop:50}} 
       >
        <div style={{ textAlign: "center" }} className={classes.root}>
          <Grid
            container
            spacing={8}
            alignItems="center"
            direction="column"
            justify="center"
          >
            <table>
              <th>
                <UploadDocSingleFile
                  //doc_name={null}
                  //file={null}
                  reset={this.state.reset}
                  toggleReset={this.toggleReset}
                  key={0}
                  fileNumber={0 + 1}
                  onAddIconClick={this.handleOnAddIcon}
                  onAddFile={this.handleAddFile}
                  onResetFile={this.handleResetFile}
                  file={this.props.files[0]}
                />
              </th>
              <th>
                {!this.state.uploading && (
                  <Button
                    variant="contained"
                    type="submit"
                    color="primary"
                    onClick={()=>{this.submitHandler()}}
                    disabled={this.state.uploading}
                    style={{
                      height: "30px",
                      width: "85px",
                      fontSize: "14px",
                      marginTop: "46px",
                      marginLeft: "15px",
                    }}
                  >
                    {this.context.t("Upload")}
                  </Button>
                )}
                {this.state.uploading && (
                  <Button
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={this.state.uploading}
                    style={{
                      height: "30px",
                      width: "85px",
                      fontSize: "14px",
                      marginTop: "46px",
                      marginLeft: "15px",
                    }}
                  >
                    {this.context.t("uploading")}
                  </Button>
                )}
                {/* {this.state.uploading && (
                  <CircularProgress
                    size={25}
                    thickness={3}
                    style={{
                      marginTop: "63px",
                      marginBottom: "-78px",
                      marginLeft: "-166px",
                    }}
                    className={classes.progress}
                  />
                )} */}
              </th>
              {/* <th>
                {!this.state.uploadingFullPdf && (
                  <Button
                    variant="contained"
                    type="submit"
                    color="primary"
                    onClick={()=>{this.submitHandlerUploadFullPdf()}}
                    disabled={this.state.uploadingFullPdf}
                    style={{
                      height: "30px",
                      width: "185px",
                      fontSize: "14px",
                      marginTop: "46px",
                      marginLeft: "15px",
                    }}
                  >
                    {this.context.t("Upload Full PDF")}
                  </Button>
                )}
                {this.state.uploadingFullPdf && (
                  <Button
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={this.state.uploadingFullPdf}
                    style={{
                      height: "30px",
                      width: "85px",
                      fontSize: "14px",
                      marginTop: "46px",
                      marginLeft: "15px",
                    }}
                  >
                    {this.context.t("uploading")}
                  </Button>
                )}
                {this.state.uploading && (
                  <CircularProgress
                    size={25}
                    thickness={3}
                    style={{
                      marginTop: "63px",
                      marginBottom: "-78px",
                      marginLeft: "-166px",
                    }}
                    className={classes.progress}
                  />
                )}
                {this.state.uploadingFullPdf && (
                  <CircularProgress
                    size={25}
                    thickness={3}
                    style={{
                      marginTop: "63px",
                      marginBottom: "-78px",
                      marginLeft: "-166px",
                    }}
                    className={classes.progress}
                  />
                )}
              </th> */}
            </table>
          </Grid>
          <Typography style={{ marginTop: "10px", textAlign: "center" }}>
            {this.context.t(
              "Please upload word (.docx) file and it will be converted to PDF automatically."
            )}
          </Typography>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.uploadDocs.loading,
    files: state.uploadDocs.files,
    userType: state.caseInfo.userType,
    caseId: state.caseInfo.caseId,
    caseData: state.caseInfo.caseData,
    claimantUniqueId: state.caseInfo.claimantUniqueId,
    respondentUniqueId: state.caseInfo.respondentUniqueId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addFile: (file, doc_name) => dispatch(actions.addFile(file, doc_name)),
    removeFile: (filename) => dispatch(actions.removeFile(filename)),
    uploadDocs: (files, conversationId, caseId, userType, doc_type) =>
      dispatch(actions.uploadWordDoc(files, conversationId, caseId, userType, doc_type)),
    uploadFullPDFDoc: (files, conversationId, caseId, userType, doc_type) =>
      dispatch(actions.uploadFullPDFDoc(files, conversationId, caseId, userType, doc_type)),
  };
};

UploadDocsSingleFile.contextTypes = {
  t: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withRouter(UploadDocsSingleFile)));
